import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface EnvConfig { readonly code: string; readonly baseUrl: string; readonly isActive: boolean; readonly databaseHost: string; }

export function EnvironmentPage(): ReactNode {
  const { token } = useAuth();
  const { t } = useTranslation();
  const [rows, setRows] = useState<EnvConfig[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ items: EnvConfig[] }>('/platform/environments', { token })
      .then((r) => { if (alive) setRows(r.items); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('common.loading')}</p>;
  return (
    <main aria-label="environment-list">
      <h1>{t('environment.title')}</h1>
      <table aria-label="environments-table">
        <thead><tr><th>{t('environment.col.code')}</th><th>{t('environment.col.url')}</th><th>{t('environment.col.active')}</th></tr></thead>
        <tbody>
          {rows.map((e) => (
            <tr key={e.code}>
              <td>{e.code}</td>
              <td>{e.baseUrl}</td>
              <td>{e.isActive ? t('common.yes') : t('common.no')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
